/**
 * Kosten- und Kostenträger-Hinweise je Leistung. Die Beträge stammen aus der
 * Pflegekosten-Seite (Stand 2026) und den gesetzlichen Regelungen des SGB V
 * und SGB XI.
 */
const serviceCosts = {
  behandlungspflege: {
    title: 'Was kostet Behandlungspflege?',
    text:
      'Behandlungspflege wird ärztlich verordnet und von der Krankenkasse übernommen, ein Pflegegrad ist dafür nicht nötig. Wir rechnen direkt mit der Kasse ab. Gesetzlich Versicherte zahlen eine Zuzahlung von 10 Prozent für die ersten 28 Tage im Kalenderjahr plus 10 Euro je Verordnung, sofern keine Befreiung vorliegt.'
  },
  grundpflege: {
    title: 'Wer zahlt die Grundpflege?',
    text:
      'Ab Pflegegrad 2 übernimmt die Pflegekasse die Grundpflege als Pflegesachleistung: 2026 bis zu 796 Euro bei Pflegegrad 2 und bis zu 2.299 Euro bei Pflegegrad 5 im Monat. Pflegegeld und Sachleistung lassen sich kombinieren. Bei Pflegegrad 1 kann der Entlastungsbetrag von 131 Euro im Monat eingesetzt werden.'
  },
  rufbereitschaft: {
    title: 'Was kostet die Rufbereitschaft?',
    text:
      'Die telefonische Erreichbarkeit rund um die Uhr gehört für unsere Kundinnen und Kunden zur Versorgung dazu. Einsätze, die daraus entstehen, rechnen wir wie die übrige Pflege mit der Pflege- oder Krankenkasse ab.'
  },
  beratung: {
    title: 'Was kostet die Beratung?',
    text:
      'Beratungsbesuche nach § 37 Abs. 3 SGB XI sind für Pflegegeld-Empfänger kostenfrei, die Pflegekasse übernimmt die Kosten. Ein erstes Gespräch zu Ihrer Situation ist bei uns unverbindlich. Wir helfen anschließend bei Anträgen und der Abrechnung mit den Kostenträgern.'
  },
  wundmanagement: {
    title: 'Wer zahlt die Wundversorgung?',
    text:
      'Die Versorgung akuter und chronischer Wunden ist Behandlungspflege: Sie wird ärztlich verordnet und über die Krankenkasse abgerechnet. Verbandmaterialien werden ebenfalls verordnet. Es gilt die gesetzliche Zuzahlung, sofern keine Befreiung vorliegt.'
  },
  palliativpflege: {
    title: 'Wer zahlt die Palliativpflege zu Hause?',
    text:
      'Palliativpflege zu Hause wird über Kranken- und Pflegekasse finanziert: pflegerische Leistungen über den Pflegegrad, verordnete Behandlungspflege über die Krankenkasse. Bei komplexem Bedarf kann die Ärztin oder der Arzt eine spezialisierte ambulante Palliativversorgung (SAPV) verordnen, die die Krankenkasse vollständig trägt.'
  },
  verhinderungspflege: {
    title: 'Wie viel steht mir für Verhinderungspflege zu?',
    text:
      'Ab Pflegegrad 2 stehen für Verhinderungspflege 2026 bis zu 3.539 Euro im Jahr zur Verfügung, als gemeinsamer Jahresbetrag mit der Kurzzeitpflege. Das Pflegegeld wird während der Verhinderungspflege anteilig weitergezahlt. Wir helfen bei Antrag und Abrechnung mit der Pflegekasse.'
  },
  pflegeakademie: {
    title: 'Was kostet die Qualifizierung?',
    text:
      'Der Basiskurs zum Alltagsbegleiter nach § 45a SGB XI kostet 445 Euro, der jährliche Refresher 245 Euro. Nach Zahlungseingang erhalten Sie die Unterlagen per E-Mail und nach erfolgreichem Abschluss Ihr Zertifikat per Post.'
  }
};

export default serviceCosts;
